import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initObservability } from "./modules/shared/lib/observability";
import "@/modules/talent/dashboard";
import "@/modules/sales/dashboard";
import "@/modules/operations/dashboard";

initObservability();

// After a deploy, users with an open tab still reference old chunk hashes.
// The S3/CloudFront SPA fallback serves index.html for those 404s, so the
// browser tries to parse HTML as JS and crashes with a MIME-type error.
// Vite emits `vite:preloadError` for exactly this case — reload once so the
// page pulls the fresh index.html and the new chunk hashes. The guard on
// sessionStorage prevents a reload loop if the failure is something else.
const RELOAD_SENTINEL = "openhub:chunk-reload";
window.addEventListener("vite:preloadError", (event) => {
  event.preventDefault();
  if (sessionStorage.getItem(RELOAD_SENTINEL)) return;
  sessionStorage.setItem(RELOAD_SENTINEL, "1");
  window.location.reload();
});
window.addEventListener("load", () => {
  sessionStorage.removeItem(RELOAD_SENTINEL);
});

createRoot(document.getElementById("root")!).render(<App />);
